import BoldText from "../BoldText/BoldText";
import DirectoryButton from "../DirectoryButton/DirectoryButton"; 
import "../../index.css";
import "./directoryCluster.css";

const DirectoryCluster= ({title, list =[], light=false}) => {

  return (
    <div className={`directory-cluster ${light ? "directory-cluster--light" : "directory-cluster--dark"}`}>
      <img
        className="directory-cluster__rose"
        src="/photo-assets/red%20rose%20icon_alpha.png"
        alt=""
        aria-hidden="true"
      />
      <div className={"directory-cluster__content"} style={{marginBottom: "6vmax"}}>
        <BoldText clr={light ? "clr-light-red" : "clr-dark-red"} marginClass={"margin-bottom-5"} class_Name="font-size-6" > {title}</BoldText>
        <div className="flex-column-centered" style={{width:"85%"}} >
          {
            list.length > 0 && list.map((item, index) => (
              <DirectoryButton  link={item.url} key={index} title={item.title} iconClass={item.iconClass} light={light} last={index === list.length - 1} class_Name={`button-adjustment bg-dark-blue`} />
            ))
          }
        </div>
      </div>
    </div>
  );
}; 


export default DirectoryCluster;